import React from 'react';
import styles from '../../components/loader/Loader.module.css';

export default function ErrorPage({ title, message, errorRedirectUrl }) {
  return (
    <div className={`d-flex align-items-center justify-content-center ${styles.loader_container}`}>
      <div className="row d-flex justify-content-center">
        <div className="col-12 mb-4 pt-1">
          <div className="p-2 text-center mx-auto w-25">
            <div>
              <img
                src="../../images/exclamation-warning-icon.svg"
                width="150"
                alt="Error Icon"
                className="img-fluid mx-auto d-block fade-in"
              />
            </div>
          </div>
        </div>
        <div>
          <h1 className="fw-bold text-center text-danger mb-4">{title || 'Oops! Something went wrong'}</h1>
          <p className="fw-bold text-center text-42526a">{message}</p>
        </div>
        <div>
          {errorRedirectUrl &&
            <div className='my-4'>
              <a href={errorRedirectUrl} className='secondary-button'>DLC Website</a>
            </div>
          }
        </div>
      </div>
    </div>
  );
}